import { fetchWithSupabaseAuth } from "../lib/supabaseClient.js";

// Carte Mise à jour refusée pour le type Citerne/Dompeur : la case enregistre la même autorisation
// que celle de la réaffectation (placement manuel accepté), puis la carte s'actualise.
export const hasDompeurMismatch = (items) => (items || []).some((item) => item?.reasonCode === "incompatible_truck");

export async function acceptTruckDompeurOverride({ truckId, dispatchDate, dispatchPeriod }) {
  const query = new URLSearchParams({ dispatch_date: dispatchDate, dispatch_period: dispatchPeriod });
  const response = await fetchWithSupabaseAuth(
    `/api/planning/source-changes/trucks/${encodeURIComponent(truckId)}/accept-dompeur?${query}`, { method: "POST" },
  );
  if (!response.ok) throw new Error("L’autorisation Citerne/Dompeur n’a pas pu être enregistrée. Réessayez.");
}
